import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'
export const TableSection = styled.div`
  width: 60%; // or whatever percent you want
  min-width: 400px;
  max-width: 800px;
`

export const Wrapper = styled.div`
    padding-bottom: 100px;
  `


  export const TableTopper = styled(Flex)`


  border: ${props =>
    props?.border ? 'none' : `1px solid ${COLORS.GREY_T_90}`};
  border-top: ${props =>
    props?.border ? 'none' : `1px solid ${COLORS.GREY_T_90}`};
  background: ${props => (props?.backgroundColor ? 'white' : '')};
`